import React from "react"
import { Link } from "gatsby"
import RandomLogo from "../../static/assets/Rlogo.svg"
import Logo from "../../static/assets/RandomLogo.svg"

function NavBar(prop) {
  const linkStyle = prop.linkStyle;
  return (
    <nav className="desktop__nav">

      {linkStyle === 'nav__link__m' ?
        (<Link to="/">
          <img src={Logo} alt="Random Logo" />
        </Link>)
        :
        (<Link to="/">
          <img src={RandomLogo} alt="Logo" />
        </Link>)
      }

      <div className="nav__links-container">
        <Link
          activeClassName={linkStyle + "-active"}
          className={linkStyle}
          to="/"
        >
          inicio
        </Link>
        <Link
          activeClassName={linkStyle + "-active"}
          className={linkStyle}
          to="/works"
        >
          trabajos
        </Link>
        <Link
          activeClassName={linkStyle + "-active"}
          className={linkStyle}
          to="/contact"
        >
          contacto
        </Link>
      </div>
    </nav>
  )
}

export default NavBar;
